// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__QRCode__MyImage__root","contents":"CentricUI__QRCode__MyImage__contents","colorCodeBackground":"CentricUI__QRCode__MyImage__colorCodeBackground","image":"CentricUI__QRCode__MyImage__image","qr":"CentricUI__QRCode__MyImage__qr","loadingPlaceholder":"CentricUI__QRCode__MyImage__loadingPlaceholder","largeImage":"CentricUI__QRCode__MyImage__largeImage","linkOffCustom":"CentricUI__QRCode__MyImage__linkOffCustom","loading":"CentricUI__QRCode__MyImage__loading","wave":"CentricUI__QRCode__MyImage__wave"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/ui/components/QRCode/MyImage.css
// module id = 669
// module chunks = 10